"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPERIMENTS_SCOPE = 'specs.groups';
exports.GROUP_LIST = 'group_list';
//https://pbo.wixpress.com/rpc-console-poc/wix-apps-webapp/app-jvm-137.42.wixprod.net/tpaDistributionService/getPublicApp?WyIzODM2YWUxOS04MDA0LTQyMmMtOTBhNC1hZWJlNzBhYWE0MjQiXQ==.e30=
exports.GROUPS_WIDGET_ID = 'a7dcdfcb-8abd-4008-af19-fed5fcd12b40';
exports.GROUP_PAGE_NAME = 'Group Page';
//# sourceMappingURL=constants.js.map